var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 9.0566C18 11.5585 16.9875 13.8226 15.3675 15.4642C14.0512 16.7774 12.33 17.6943 10.4062 18V11.6717H12.4987L12.9038 9.0566H10.4062V7.35849C10.4062 6.64528 10.755 5.9434 11.8688 5.9434H13.005V3.71321C13.005 3.71321 11.9813 3.53208 10.9913 3.53208C8.9325 3.53208 7.59375 4.78868 7.59375 7.06415V9.0566H5.31V11.6717H7.59375V18C5.67 17.6943 3.94875 16.7774 2.6325 15.4642C1.0125 13.8226 0 11.5585 0 9.0566C0 6.55472 1.0125 4.29057 2.6325 2.64906C4.26375 1.01887 6.51375 0 9 0C13.9725 0 18 4.05283 18 9.0566Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/FB.da8b11b3a6980eed88255dd95ac82a73.svg";
export { ForwardRef as ReactComponent };